<template lang="pug">
  div.wrap-module-add-course
    div(v-for="item in courses"
      @click="$router.push(`/course/${item.id}`)").course
      div.wrap-img.f.fh
        img(:src="item.mainImg").object-fit-cover
      div.course-info
        div.info-content.py10
          span.fz16.bold.block.mb2 {{item.title}}
          span.block {{item.price}}
</template>

<style lang="scss" scoped>
.wrap-module-add-course {
  width: 100%;
  min-height: 100vh;
  padding-top: 48px;
  .course {
    border-bottom: solid #999 1px;
    .wrap-img {
      max-width: 420px;
      max-height: 280px;
      margin: 0 auto;
      overflow: hidden;
      img {
        width: 100%;
      }
    }
    .course-info {
      .info-content {
        width: 93%;
        max-width: 420px;
        margin: 0 auto;
      }
    }
  }
}
</style>

<script>
import db from '@/components/utils/firebase'
import { createNamespacedHelpers } from 'vuex'
const { mapState: mapStateAuth, mapActions: mapActionsAuth } = createNamespacedHelpers('auth')
import { database } from '@shared/database'

export default {
  components: {
  },
  computed: {
    ...mapStateAuth(['uid'])
  },
  data () {
    return {
      user: null,
      courses: [],
      showModal: true
    }
  },
  async created () {
    // this.user = await db.collection("USERS")
    //   .doc(this.uid)
    //   .get()
    //   .then(d => { return d.data() })
    this.user = await database.getTrainee(this.uid)

    // this.courses = await db.collection("COURSES")
    //   .get()
    //   .then(q => {
    //     return q.docs.map(d => {
    //       var data = d.data()
    //       data.id = d.id
    //       return data
    //     })
    //   })
    this.courses = await database.getAllCourses()
  },
  methods: {
    ...mapActionsAuth(['signOut']),
    onLoggedIn () {
      
    },
    onFailedAuthentication () {
      this.$router.push('/sign-in')
    }
  }
}
</script>
